export const dataConstants = {
	insuranceProvider: 'insuranceProvider',
	insuranceProviderName: 'insuranceProviderName',
	insuranceInNetwork: 'insuranceInNetwork',
};
